<template>
    <component :is="template">
        <div>
            <div class="tit-wrap tit-wrap--unberline" v-if="detect == 'pc'">
                <h2 class="tit">교환 내역</h2>
            </div>

            <v-divider class="d-md-none" />

            <mypage-dashboard-head class="mb-2 mb-md-12" :class="{ 'mt-n7': detect == 'mobile' }" />

            <v-card elevation="0" style="overflow:visible">
                <v-card-text :class="{ 'pa-0': detect == 'pc' }">
                    <div class="mb-4">
                        <exchange-bulk-list-filter />
                    </div>

                    <exchange-bulk-list-type class="mb-2 mb-md-12" />

                    <div>
                        <v-data-table
                            v-bind="{
                                items,
                                headers,
                                itemsPerPage: -1,
                            }"
                            hide-default-footer
                            disable-pagination
                            disable-sort
                            class="exchange-table"
                        >
                            <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value, item)" /> </template>
                            <template #[`item.cash`]="{ item }">
                                <exchange-bulk-item-cash v-bind="{ value: item }" @input="updateItem" />
                            </template>
                            <template #[`item.gift`]="{ item }">
                                <exchange-bulk-item-gift v-bind="{ value: item }" @input="updateItem" />
                            </template>
                            <template #[`item.prev`]="{ value, item, header }">
                                <exchange-bulk-item-prev v-bind="{ value: item }" v-slot="{ attrs, on }">
                                    <v-card color="transparent" elevation="0" v-bind="attrs" v-on="on">
                                        {{ header.formatter.bind(item)(value, item) }}
                                    </v-card>
                                </exchange-bulk-item-prev>
                            </template>
                            <template #[`item.undo`]="{ item }">
                                <exchange-bulk-item-undo v-bind="{ value: item }" @input="updateItem" />
                            </template>
                        </v-data-table>
                    </div>

                    <div class="mt-30px mt-md-40px">
                        <v-pagination
                            v-bind="{
                                value: page,
                                length: pageCount,
                                'total-visible': 11,
                            }"
                            @input="(page) => $router.push({ query: { ...$route.query, page } })"
                        />
                    </div>
                </v-card-text>
            </v-card>
        </div>
        <common-loader v-bind="{ loading }" />
    </component>
</template>
<script>
import api from "@/api";
import detect from "@/plugins/detect";
import { initDataTableHeaders } from "@/assets/lib";

import CommonLoader from "@/components/common/common-loader.vue";
import ExchangeBulkItemCash from "@/components/client/mypage/exchange/exchange-bulk-item-cash.vue";
import ExchangeBulkItemGift from "@/components/client/mypage/exchange/exchange-bulk-item-gift.vue";
import ExchangeBulkItemPrev from "@/components/client/mypage/exchange/exchange-bulk-item-prev.vue";
import ExchangeBulkItemUndo from "@/components/client/mypage/exchange/exchange-bulk-item-undo.vue";
import ExchangeBulkListFilter from "@/components/client/mypage/exchange/exchange-bulk-list-filter.vue";
import ExchangeBulkListType from "@/components/client/mypage/exchange/exchange-bulk-list-type.vue";
import MypageDashboardHead from "@/components/client/mypage/dashboard/mypage-dashboard-head.vue";

export default {
    components: {
        CommonLoader,
        ExchangeBulkItemCash,
        ExchangeBulkItemGift,
        ExchangeBulkItemPrev,
        ExchangeBulkItemUndo,
        ExchangeBulkListFilter,
        ExchangeBulkListType,
        MypageDashboardHead,
    },
    data: () => ({
        /** @type {import('@/assets/lib').UserExchangeBulk[]} */
        bulks: [],
        summary: { totalCount: 0 },

        limit: 10,
        detect,

        loading: false,
    }),
    computed: {
        template() {
            switch (detect) {
                case "pc": {
                    return () => import(`@/templates/${this.$theme.pages.mypage}`);
                }

                case "mobile": {
                    return () => import(`@/templates/${this.$theme.pages.default}`);
                }
            }
        },
        headers() {
            return initDataTableHeaders([
                {
                    text: "No",
                    value: "index",
                    align: "end",
                    width: +60,
                    formatterType: "number",
                },
                {
                    text: "일시",
                    value: "createdAt",
                    align: "center",
                    width: 110,
                    formatterType: "datetime",
                },
                {
                    text: "교환소",
                    value: "codeText",
                    align: "center",
                    width: +80,
                },
                {
                    text: "교환권 번호",
                    value: "prev",
                    align: "center",
                    formatter: (value, item) => {
                        let items = item.exchanges.filter((item) => item.done && !item.fail);
                        let text = items[0]?.prev;
                        if (!text) return "-";
                        if (0 < items.length) text += ` 외 ${(items.length - 1).format()}건`;
                        return text;
                    },
                },
                {
                    text: "금액",
                    value: "amount",
                    align: "center",
                    formatterType: "number",
                    suffix: "원",
                    width: 110,
                },
                {
                    text: "상태",
                    value: "type",
                    align: "center",
                    width: 100,
                },
                {
                    text: "충전하기",
                    value: "cash",
                    align: "center",
                    width: 100,
                },
                {
                    text: "선물하기",
                    value: "gift",
                    align: "center",
                    width: 100,
                },
                // {
                //     text: "취소하기",
                //     value: "undo",
                //     align: "center",
                //     width: 100,
                // },
            ]);
        },
        items() {
            return [...this.bulks].map((item, index) => ({ ...item, index: this.summary.totalCount - this.skip - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { type, ...query } = this.$route.query;

            delete query.page;

            query.done = true;
            query.fail = false;

            switch (type) {
                case "cashed": {
                    query.cashed = true;
                    query.gifted = JSON.stringify({ $ne: true });
                    break;
                }
                case "gifted": {
                    query.cashed = JSON.stringify({ $ne: true });
                    query.gifted = true;
                    break;
                }
                case "gifted-cashed": {
                    query.cashed = true;
                    query.gifted = true;
                    break;
                }
                case "isDone": {
                    query.cashed = JSON.stringify({ $ne: true });
                    query.gifted = JSON.stringify({ $ne: true });
                    break;
                }

                default:
                    break;
            }

            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                let { summary, bulks } = await api.v1.me.exchanges.bulks.gets({
                    headers: { skip, limit },
                    params,
                });

                this.bulks = bulks;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },

        updateItem(item) {
            const index = this.bulks.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.bulks.splice(index, 1, item);
            else {
                this.bulks = [item, ...this.bulks];
                this.summary.totalCount += 1;
            }
            this.search();
        },
    },
};
</script>

<style lang="scss" scoped>
.exchange-table {
    &,
    ::v-deep *,
    ::v-deep td {
        font-size: 14px !important;
        line-height: 1.25 !important;
    }
}
</style>
